import {DropdownNavigation} from '@cohort/wallet/components/navigation/DropdownNavigation';
import Navbar from '@cohort/wallet/components/navigation/NavBar';
import TestModeBanner from '@cohort/wallet/components/testMode/TestModeBanner';
import useHandleLoginNavigation from '@cohort/wallet/hooks/handleLoginNavigation';
import useLazyRouteLoader from '@cohort/wallet/hooks/lazyRouteLoader';
import {useAppStore} from '@cohort/wallet/hooks/stores/app';
import {useMerchantContext} from '@cohort/wallet/hooks/useMerchantContext';
import useStoreContext from '@cohort/wallet/hooks/useStoreContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {getStoreLoginRoute} from '@cohort/wallet/lib/Pages';
import {setAmplitudeMetadata} from '@cohort/wallet/lib/Tracking';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet, useNavigate} from 'react-router-dom';

const StoreLayout = (): JSX.Element => {
  const {t} = useTranslation('layouts', {
    keyPrefix: 'store.storeLayout',
  });
  const {campaign, buyingStep, setTransitioning} = useStoreContext();
  const merchant = useMerchantContext();
  const {setCampaignTheme} = useThemeContext();
  const navigate = useNavigate();
  const {withNavbar, disableLogout, embedded} = useAppStore(store => ({
    disableLogout: store.disableLogout,
    embedded: store.embedded,
    withNavbar: store.withNavbar,
  }));
  const loader = useLazyRouteLoader();
  const navigateToLogin = useHandleLoginNavigation();

  useEffect(() => {
    setCampaignTheme(campaign);
  }, [campaign, setCampaignTheme]);

  useEffect(() => {
    setAmplitudeMetadata(merchant, campaign);
  }, [campaign, merchant]);

  return (
    <div
      className="relative grid overflow-hidden [grid-template-rows:min-content_max-content_1fr]"
      style={{
        height: embedded ? window.innerHeight : '100svh',
        maxHeight: embedded ? '100%' : '100lvh',
        gridTemplateAreas: `
        "testModeBanner"
        "header"
        "main"
      `,
      }}
    >
      <TestModeBanner />
      {withNavbar ? (
        <Navbar
          campaignSlug={campaign.store.slug}
          handleBackButtonClick={() => {
            setTransitioning(true);
            navigate(-1);
          }}
          logoFileKey={merchant.logoFileKey}
          appTitle={t('experienceStoreTitle', {name: merchant.name})}
        >
          <div className="flex h-full items-center justify-end pr-8">
            <DropdownNavigation
              withBackButton={buyingStep.current !== 0}
              handlelogin={navigateToLogin}
              showExperienceSpace
              showHelp
              showLogout={!disableLogout}
              logOutSuccessRoute={getStoreLoginRoute(campaign.store.slug)}
            />
          </div>
        </Navbar>
      ) : (
        <div />
      )}
      <div className="h-full overflow-auto">
        {loader}
        <Outlet />
      </div>
    </div>
  );
};

export default StoreLayout;
